import { initSentry } from './observability/sentry.js';
import { ClientStore } from './state/clientStore.js';
import { ServerClock } from './state/clock.js';
import { GeometryEpochHub } from './state/geometryEpochHub.js';
import { connectWs } from './ws/client.js';
import { bootstrapSnapshot } from './ws/bootstrapSnapshot.js';
import { startClock } from './hud/clock.js';
import { createPersistentVisibility } from './hud/visibility.js';
import { beginResumeFrame } from './layers/pageResume.js';
import { createViewRouter } from './router.js';
import { createMapView,type MapViewState } from './map/view.js';
import { createTycoonView } from './tycoon/view.js';
import type { CameraState } from './tycoon/projection.js';
import { createTycoonMotion } from './tycoon/motion.js';
import { createFrameLoop } from './frameLoop.js';
import type { RendererAdapterFactory } from './tycoon/rendererAdapter.js';

void initSentry();
const store=new ClientStore(),clock=new ServerClock(),visibility=createPersistentVisibility(import.meta.env.VITE_TOMTOM_API_KEY?[]:['traffic']);
const geometryEpochs=new GeometryEpochHub();
const tycoonMotion=createTycoonMotion();
const createProductionRenderer:RendererAdapterFactory=async options=>{
  const {createPixiRendererAdapter}=await import('./tycoon/pixiRendererAdapter.js');
  return createPixiRendererAdapter(options);
};
const wsUrl=import.meta.env.VITE_WS_URL??`${location.protocol==='https:'?'wss':'ws'}://${location.host}/ws`;
void bootstrapSnapshot({baseUrl:import.meta.env.VITE_API_BASE??'',store,clock});connectWs({url:wsUrl,store,clock,geometryEpochs});
startClock(document.getElementById('hud-clock')!,()=>clock.nowMs());
let router:ReturnType<typeof createViewRouter>;
router=createViewRouter({
  map:(state)=>createMapView({store,clock,visibility,initialState:state as MapViewState|undefined,navigateTycoon:()=>router.navigate('/tycoon'),geometryEpochs}),
  tycoon:(state)=>createTycoonView({root:document.body,store,clock,visibility,motion:tycoonMotion,atlasContract:__TYCOON_ATLAS_CONTRACT__,rendererFactory:new URLSearchParams(location.search).get('tycoonRenderer')==='canvas'?undefined:createProductionRenderer,initialState:state as CameraState|undefined,navigateMap:()=>router.navigate('/')}),
});
createFrameLoop(() => { beginResumeFrame(); router.frame(); })();
